var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdResourcesBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homeowner_Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "premiumIcon",
    id: "Menu-Options",
    transform: "translate(-80.000000, -288.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(3.000000, 288.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92,0 C83.72,0 77,6.72 77,15 C77,23.28 83.72,30 92,30 C100.28,30 107,23.28 107,15 C107,6.72 100.28,0 92,0 Z M93.5,22.5 L90.5,22.5 L90.5,13.5 L93.5,13.5 L93.5,22.5 Z M93.5,10.5 L90.5,10.5 L90.5,7.5 L93.5,7.5 L93.5,10.5 Z",
    id: "Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdResourcesBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Ed_resources_blue.3636a852a8802e7f511353f3bbc2aab6.svg";